import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-type-packages',
  templateUrl: './type-packages.component.html',
  styleUrls: ['./type-packages.component.scss'],
})
export class TypePackagesComponent implements OnInit {
  breadcrumbs: any;
  packageTypeForm: any = FormGroup;
  submitted: boolean = false;
  isSaved: boolean = false;
  isDisplayed: boolean = false;
  generalMessage: string = '';
  officeId: string | null = '';
  isEdited: boolean = false;
  checkedDepilacion: boolean = false;
  checkedHidra: boolean = false;
  checkedRadio: boolean = false;
  checkedEterna: boolean = false;
  checkedMadero: boolean = false;

  constructor(
    private api: ApiService,
    private fb: FormBuilder,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.officeId = this.route.snapshot.paramMap.get('id');
    this.breadcrumbs = [
      {
        name: 'Agenda',
        path: '/dashboard/new-calendar',
        link: true,
      },
      {
        name: 'Lista de sucursales',
        path: '/offices/list',
        link: true,
      },
      {
        name: 'Configuracion de paquetes por sucursal',
        link: false,
      },
    ];

    this.validations();
    this.getOfficeData();
  }

  validations(): void {
    this.packageTypeForm = this.fb.group({
      officeId: ['', [Validators.required]],
      depilacion: [false],
      radio: [false],
      hidra: [false],
      eterna: [false],
      madero: [false],
      ids: [''],
    });

    this.packageTypeForm.patchValue({
      officeId: this.officeId,
    });
  }

  get f() {
    return this.packageTypeForm.controls;
  }

  private setCheckbox(idx: Number, value: boolean) {
    if (idx == 1) {
      this.checkedDepilacion = value ? true : false;
    } else if (idx == 2) {
      this.checkedHidra = value ? true : false;
    } else if (idx == 3) {
      this.checkedRadio = value ? true : false;
    } else if (idx == 4) {
      this.checkedEterna = value ? true : false;
    } else {
      this.checkedMadero = value ? true : false;
    }
  }

  getOfficeData() {
    this.api.getById('offices/type', Number(this.officeId)).subscribe({
      next: (data) => {

        console.log('data: ', data);

        if (data.total > 0) {
          this.isEdited = true;
          const internalIds: number[] = [];
          for (let i = 0; i < data.total; i++) {
            internalIds.push(data.data[i].id);
            this.setCheckbox(i + 1, data.data[i].isActive);
          }

          this.packageTypeForm.patchValue({
            ids: internalIds,
            depilacion: data.data[0]?.isActive,
            radio: data.data[2]?.isActive,
            hidra: data.data[1]?.isActive,
            eterna: data.data[3]?.isActive,
            madero: data.data[4]?.isActive,
          });
        }
      },
      error: (err) => {},
    });
  }

  createUpdateType() {
    this.submitted = true;

    if (this.packageTypeForm.invalid) {
      this.submitted = false;
      return;
    }

    const arrayActives: any = [];
    arrayActives.push(
      this.packageTypeForm.value.depilacion,
      this.packageTypeForm.value.hidra,
      this.packageTypeForm.value.radio,
      this.packageTypeForm.value.eterna,
      this.packageTypeForm.value.madero,
    );

    const obj = {
      types: [1, 2, 3, 4, 5],
      actives: arrayActives,
      officeId: Number(this.officeId),
      ids:
        this.packageTypeForm.value.ids.length > 0
          ? this.packageTypeForm.value.ids
          : '',
    };

    if (this.isEdited) {
      this.api.update('offices/type', Number(this.officeId), obj).subscribe({
        next: (data) => {
          this.submitted = false;
          this.isSaved = true;
          this.generalMessage = data.message;

          setTimeout(() => {
            this.isSaved = false;
            this.generalMessage = '';
          }, 3000);
        },
        error: (err) => {},
      });
    } else {
      this.api.create('offices/type', obj).subscribe({
        next: (data) => {
          this.submitted = false;
          this.isSaved = true;
          this.generalMessage = data.message;

          setTimeout(() => {
            this.isSaved = false;
            this.generalMessage = '';
          }, 3000);
        },
        error: (err) => {},
      });
    }
  }

  setValue(event: any, type: number) {
    if (type == 1) {
      this.packageTypeForm.patchValue({
        depilacion: event.target.checked,
      });
    } else if (type == 2) {
      this.packageTypeForm.patchValue({
        hidra: event.target.checked,
      });
    } else if (type == 3) {
      this.packageTypeForm.patchValue({
        radio: event.target.checked,
      });
    } else if (type == 4) {
      this.packageTypeForm.patchValue({
        eterna: event.target.checked,
      });
    } else {
      this.packageTypeForm.patchValue({
        madero: event.target.checked,
      });
    }
  }
}
